import { useQuery } from '@tanstack/react-query';
import type { ProjectCapabilities } from '@marketing-hub/shared';
import { apiFetch } from '@/api/client';

const ADMIN_FALLBACK: ProjectCapabilities = {
  role: 'admin',
  leads_read: true,
  leads_write: true,
  campaigns_draft: true,
  campaigns_start: true,
  automations_read: true,
  automations_write: true,
  webhooks_manage: true,
  settings_manage: true,
  members_manage: true,
};

export function useProjectRole(projectId: string | null | undefined) {
  const q = useQuery({
    queryKey: ['project-role', projectId],
    enabled: Boolean(projectId),
    queryFn: () =>
      apiFetch<{ capabilities: ProjectCapabilities }>(`/api/projects/${projectId}/me-role`),
    staleTime: 60_000,
  });

  const caps = q.data?.capabilities ?? (q.isLoading ? null : ADMIN_FALLBACK);

  function can(cap: keyof Omit<ProjectCapabilities, 'role'>): boolean {
    if (!caps) return true;
    return caps[cap];
  }

  return { capabilities: caps, isLoading: q.isLoading, can, role: caps?.role ?? 'admin' };
}
